var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { transient, autoinject } from 'aurelia-dependency-injection';
import { BaseInstantGame } from '../../base-instant-game';
import { ClientLotteryClientService } from '../../../../../services/modules/client/client-lottery-client-service';
import { Router } from 'aurelia-router';
import { TokenClient } from '../../../../../services/authentication/token-client.service';
import { NotificationClientService } from '../../../../../services/basics/notification-client.service';
import { I18N } from 'aurelia-i18n';
import { DialogClientService } from '../../../../../services/basics/dialog-client.service';
import { BindingSignaler } from 'aurelia-templating-resources';
import { GamePlayerTicketClientService } from '../../../../../services/modules/client/client-game-player-ticket-client.service';
import { NavigationClientService } from '../../../../../services/modules/navigation-client.service';
import { RequestClient } from '../../../../../services/basics/request-client.service';
var InstantGameDialog = /** @class */ (function (_super) {
    __extends(InstantGameDialog, _super);
    function InstantGameDialog(lotteryClientService, router, tokenClientService, notificationClientService, i18N, dialogClientService, bindingSignaler, gamePlayerTicketClientService, requestClient, navigationClientService) {
        return _super.call(this, lotteryClientService, router, tokenClientService, notificationClientService, i18N, dialogClientService, bindingSignaler, gamePlayerTicketClientService, requestClient, navigationClientService) || this;
    }
    InstantGameDialog = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [ClientLotteryClientService, Router,
            TokenClient, NotificationClientService,
            I18N, DialogClientService, BindingSignaler, GamePlayerTicketClientService,
            RequestClient, NavigationClientService])
    ], InstantGameDialog);
    return InstantGameDialog;
}(BaseInstantGame));
export { InstantGameDialog };
